<mat-form-field appearance="outline">
  <div [formGroup]="placeForm" class="search-wrapper">
    <div class="search-icon-wrapper">
      @if (isLocationLoading()) {
        <app-spinner-circle
          [position]="CssPositionEnum.ABSOLUTE"
          [size]="'1.5rem'"
        ></app-spinner-circle>
      } @else {
        <app-ui-icon
          color="var(--grey-3)"
          name="marker"
          size="md"
        ></app-ui-icon>
      }
    </div>
    <input
      #placesInput
      (focus)="onPlaceFocus($event)"
      (keydown.enter)="onPlaceEnterHit()"
      autoComplete="off"
      class="test-search-autocomplete-input"
      formControlName="term"
      matInput
      placeholder="Välj plats"
      type="search"
    >
    @if (isTermPlacesNotEmpty() && !isLocationLoading()) {
      <div (click)="onPlaceClear()" class="close-icon-wrapper">
        <app-ui-icon color="var(--grey-3)" name="close" size="md"></app-ui-icon>
      </div>
    }
  </div>
</mat-form-field>
